<template>
  <section
    id="welcome"
    class="hide-overflow"
  >
    <v-layout>
      <v-flex
        hidden-sm-and-down
        md6
      >
        <v-img
          :src="'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2FDLS_h_1000.jpg?alt=media&token=61e71562-3f37-4fa0-999f-4e9c429a7dc4'"
          height="100vh"
        />
      </v-flex>

      <v-flex
        xs12
        md6
        align-content-space-between
        layout
        :pa-5="$vuetify.breakpoint.smAndDown"
        wrap
      >
        <base-bubble-1
          style="transform: rotate(180deg) translateY(25%)"
        />

        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs10
            md8
          >
            <base-heading
              id="Hello"
            >
              {{ $t('hello') }}
            </base-heading>
            <base-text v-show="!more">
              {{ $t("whatIdo") }}
            </base-text>

            <base-text v-show="more">
              {{ $t('textAboutTwo') }}
            </base-text>

            <v-btn
              v-show="!more"
              class="mt-4"
              color="#D2B48C"
              @click="changeMore"
            >
              {{ $t('more') }}
            </v-btn>
            <v-btn
              v-show="more"
              class="mt-4"
              color="#D2B48C"
              @click="more = !more"
            >
              {{ $t('rollUp') }}
            </v-btn>
          </v-flex>
        </v-layout>

        <base-bubble-2
          style="transform: rotate(180deg) translate(-200px, -15%)"
        />
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
export default {
  data () {
    return {
      more: false
    }
  },
  methods: {
    changeMore () {
      this.more = true
    }
  }
}
</script>
